//There are parameters from the BE config
const defaultState = {
  configParameters: undefined
};

const configParametersActionTypes = {
  SET_CONFIG_PARAMETERS: 'SET_CONFIG_PARAMETERS',
};

const configParametersActions = function (state = defaultState, { type, payload }) {
  switch (type) {
    case configParametersActionTypes.SET_CONFIG_PARAMETERS:
      return {
        ...state,
        configParameters: payload
      };
    default:
      return state;
  }
};

export default configParametersActions;

// ACTIONS
export const setConfigParameters = payload => ({
  type: configParametersActionTypes.SET_CONFIG_PARAMETERS,
  payload
});